import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { useSeo } from '../hooks/useSeo';
import { HOME_PATH, PROJECTS_PATH } from '../routes';
import './LandingPage.css';
import './ProjectsPage.css';

// The server answers every unknown path with 200 and the home page's HTML, so
// this noindex is what keeps such URLs from being indexed as duplicates.
function NotFoundPage() {
  useSeo('notFound.seo', { noindex: true });
  const { t } = useTranslation();

  return (
    <div className="landing-page">
      <Navigation />
      <header className="projects-page-head not-found">
        <p className="section-eyebrow">404</p>
        <h1 className="projects-page-title">{t('notFound.heading')}</h1>
        <p className="projects-page-desc">{t('notFound.body')}</p>
        <div className="not-found-links">
          <Link to={HOME_PATH} className="group-switch-btn active">{t('notFound.home')}</Link>
          <Link to={PROJECTS_PATH} className="group-switch-btn">{t('notFound.projects')}</Link>
        </div>
      </header>
      <Footer />
    </div>
  );
}

export default NotFoundPage;
